import { render } from "./customizeSetup.vue?vue&type=template&id=58fda280&scoped=true"
import script from "./customizeSetup.vue?vue&type=script&lang=js"
export * from "./customizeSetup.vue?vue&type=script&lang=js"

import "./customizeSetup.vue?vue&type=style&index=0&id=58fda280&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58fda280"]])

export default __exports__